/* ============================================================
   cart-bundle-enforce.js – FINAL FOR SENSE THEME
   ------------------------------------------------------------
   ✔ Detects incomplete bundles
   ✔ Removes discount instantly when bundle < required items
   ✔ Prevents Shopify from re-applying discount on 1 item
   ✔ Works with Sense theme cart AJAX (cart:requestComplete)
============================================================ */

(function () {

  const EXPECTED = 2;        // Bundle size
  const POLL = 1500;         // Poll fallback

  /* Fetch latest cart */
  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(res => res.json());
  }

  /* Some Shopify themes strip leading underscore — fix */
  function prop(props, key) {
    return props?.[`_${key}`] || props?.[key] || null;
  }

  /* Remove discount code completely */
  function removeDiscount() {
    console.warn("🔴 Removing discount because bundle incomplete");

    // Remove ?discount from URL
    if (location.search.includes("discount")) {
      location.href = "/cart";
      return;
    }

    // Shopify API: POST empty discount array
    fetch("/discounts.json", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount_code: "" })
    }).finally(() => {
      location.href = "/cart";
    });
  }

  /* Disable checkout if needed */
  function disableCheckout(message) {
    const buttons = document.querySelectorAll(
      ".cart__checkout-button, [name='checkout'], [data-checkout-button]"
    );

    buttons.forEach(btn => {
      btn.disabled = true;
      btn.dataset.bundleBlocked = "true";
    });

    let msg = document.getElementById("bundle-enforce-msg");
    if (!msg) {
      msg = document.createElement("div");
      msg.id = "bundle-enforce-msg";
      msg.style.cssText =
        "background:#ffeaea;border:1px solid #ffb5b5;color:#8a0000;" +
        "padding:12px;margin-bottom:12px;font-weight:600;border-radius:6px;";
      document.querySelector("#main-cart-footer")?.prepend(msg);
    }

    msg.textContent = message;
  }

  /* Re-enable checkout */
  function enableCheckout() {
    document.querySelectorAll("[data-checkout-button], .cart__checkout-button")
      .forEach(btn => {
        if (btn.dataset.bundleBlocked) {
          btn.disabled = false;
          delete btn.dataset.bundleBlocked;
        }
      });

    const msg = document.getElementById("bundle-enforce-msg");
    if (msg) msg.remove();
  }

  /* MAIN ENFORCEMENT */
  function enforce() {
    return fetchCart().then(cart => {

      let bundles = {};
      let discountApplied = cart.discount_codes?.length > 0;
      let urlDiscount = new URL(location.href).searchParams.get("discount");

      /* Map bundle items */
      cart.items.forEach(item => {
        const props = item.properties || {};

        const bundleId = prop(props, "bundle_id");
        const isBundle = prop(props, "is_bundle");

        if (!bundleId || !isBundle) return;

        if (!bundles[bundleId]) bundles[bundleId] = [];
        bundles[bundleId].push(item);
      });

      /* Check if ANY bundle is incomplete */
      let incomplete = false;

      Object.keys(bundles).forEach(id => {
        if (bundles[id].length < EXPECTED) {
          incomplete = true;
        }
      });

      /* CASE A — incomplete + ?discount → reload without discount */
      if (incomplete && urlDiscount) {
        console.warn("🔴 Bundle incomplete — URL discount detected — reloading clean cart");
        location.href = "/cart";
        return;
      }

      /* CASE B — incomplete + discount applied → remove it */
      if (incomplete && discountApplied) {
        return removeDiscount();
      }

      /* CASE C — incomplete but no discount → block checkout */
      if (incomplete) {
        disableCheckout("Bundle incomplete — add missing item to unlock discount.");
        return;
      }

      /* CASE D — bundle complete */
      enableCheckout();
    });
  }

  /* Initialize enforcement */
  document.addEventListener("DOMContentLoaded", function () {

    enforce();

    /* SENSE THEME EVENTS — THIS IS THE FIX YOU WERE MISSING */
    [
      "cart:updated",
      "cart:change",
      "ajaxCart.afterRender",
      "cart:refresh",
      "cart:requestComplete"   // 🔥 THIS EVENT WAS MISSING — now removal works!
    ].forEach(ev => {
      document.addEventListener(ev, enforce);
    });

    /* Fallback if theme misses events */
    setInterval(enforce, POLL);
  });

})();
